import { display_message_to_user } from '@phi/logging/frontend';
import { ENV } from '@phi/config/frontend';
import App from './application-container';

/** A flag telling us to bypass user authentication and proceed with normal core operation, even if user doesn't
 * have permission. We use this ot allow core-related operations for sending models to Onshape etc.
 *
 * TODO: this is a hack, and in the future we should have separate handling for interactive vs non-interactive commands
 */
let suppress_user_authentication_and_allow_core_operations = 0;

export function check_that_user_subscription_is_valid(app = App, log = display_message_to_user, env = ENV) {
    if (user_core_permission_checks_are_suppressed())
        return true;
    else if (env === 'development')
        return true;
    else if (
        App.deviceStorage.user_subscription_status === 'free'
        || App.deviceStorage.user_subscription_status === undefined
    )
        return false;
    else
        return true;
}

export function withSuppressedPermissionChecks<XS extends any[], R>(f: (...xs: XS) => R) {
    return function (...xs: XS): R {
        try {
            suppress_user_authentication_and_allow_core_operations++;
            const x = f(...xs);
            if (x instanceof Promise)
                x.finally(() => suppress_user_authentication_and_allow_core_operations--);
            else
                suppress_user_authentication_and_allow_core_operations--;
            return x;
        } catch (e) {
            console.error(e);
            suppress_user_authentication_and_allow_core_operations--;
            throw e;
        }
    };
}

const user_core_permission_checks_are_suppressed = () => suppress_user_authentication_and_allow_core_operations > 0;
